import { render, staticRenderFns } from "./cmp-left-mid-two.vue?vue&type=template&id=21bc7340"
import script from "./cmp-left-mid-two.vue?vue&type=script&lang=js"
export * from "./cmp-left-mid-two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports